import { faSwap } from '@fortawesome/pro-solid-svg-icons';
import { unwrapResult } from '@reduxjs/toolkit';
import { setTokenCookie } from '@root/utils/cookies/cookies';
import { useRef, useState } from 'react';
import { useQuery } from 'react-query';
import { useDispatch } from 'react-redux';
import userService from 'services/userService';
import { DeprecatedComboDropdown } from 'stylus-ui/DeprecatedComboDropdown';
import { Icon } from 'stylus-ui/Icon';
import { cn } from 'utils/cn';

const DEFAULT_PASSWORD = 'testpassword';
const handleLogin = async (email, dispatch) => {
  const { loginWithEmailAndPassword, setToken } = await import('slices/authSlice');

  // @ts-expect-error - Should be solved when migrated to React-Query
  dispatch(loginWithEmailAndPassword({ email: email.toLowerCase(), password: DEFAULT_PASSWORD }))
    .then(unwrapResult)
    .then(async (tokenInfo) => {
      if (tokenInfo && (tokenInfo.token || tokenInfo.refresh)) {
        const { token, refresh } = tokenInfo;

        setTokenCookie({ access: token, refresh });
        try {
          // @ts-expect-error - TODO: Adjust param types
          dispatch(setToken({ token, refresh }));
        } catch (e) {
          console.error('Failed to set token in store: ', e);
        }
        window.location.reload();
      }
    });
};

const UserSwitcher = () => {
  if (!global.window) {
    return;
  }
  const dispatch = useDispatch();
  const [isOpen, setIsOpen] = useState(false);
  const {
    data: users
    // isLoading,
    // error
  } = useQuery(
    ['userSwitcher'], // The first argument is the query key
    userService.switcher, // The second argument is the query function
    { enabled: isOpen } // The query will not automatically run until showSearch is true
  );
  const userOptions =
    users?.map((user) => {
      return { label: user.email, id: user.email };
    }) || [];

  const workspaceFilterTrigger = useRef(null);
  const renderTrigger = ({ className }: { className: string }) => (
    <span className={cn(className, 'flex flex-row items-center gap-x-1')} ref={workspaceFilterTrigger}>
      <Icon icon={faSwap} />
    </span>
  );

  return (
    <div className='fixed bottom-2 right-4 rounded' data-testid='user-switcher'>
      <DeprecatedComboDropdown
        onOpenChange={setIsOpen}
        key='user-switcher'
        selectedOptions={[]}
        onSelect={(option) => {
          handleLogin(option.label, dispatch);
        }}
        onRemove={undefined}
        renderOption={({ label }) => (
          <div className='flex items-center rounded'>
            <div className='truncate text-sm text-slate-900'>{label}</div>
          </div>
        )}
        renderTrigger={renderTrigger}
        options={userOptions}
        placeholder='Change User'
        asPortal={false}
        zIndex={1000000}
        align='start'
        avoidCollisions
        collisionPadding={10}
      />
    </div>
  );
};

export default UserSwitcher;
